import { Outlet } from "react-router-dom";

export default function EventSlugLayout() {
  return <Outlet />;
}
